import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconFlagTu = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 512 512" size={size}>
      <g>
        <rect fill="#D00027" height="298.7" width="512" y="106.7" />
        <path fill="#FFFFFF" d="M149.3,181.3c41.2,0,74.7,33.4,74.7,74.7c0,41.2-33.4,74.7-74.7,74.7c-41.2,0-74.7-33.4-74.7-74.7   C74.7,214.8,108.1,181.3,149.3,181.3" />
        <path fill="#D00027" d="M168,196.3c33,0,59.7,26.8,59.7,59.7c0,33-26.7,59.7-59.7,59.7c-33,0-59.7-26.8-59.7-59.7   C108.3,223,135,196.3,168,196.3" />
        <polygon fill="#FFFFFF" points="212.4,256 247.9,267.5 253.7,249.8  " />
        <polygon fill="#FFFFFF" points="212.4,256 247.9,244.5 253.7,262.2  " />
        <polygon fill="#FFFFFF" points="238.2,220.5 238.2,257.8 256.9,257.8  " />
        <polygon fill="#FFFFFF" points="238.2,220.5 260.2,250.7 245.1,261.7  " />
        <polygon fill="#FFFFFF" points="238.2,291.5 260.2,261.3 245.1,250.3  " />
        <polygon fill="#FFFFFF" points="238.2,291.5 238.2,254.2 256.9,254.2  " />
        <polygon fill="#FFFFFF" points="280,234.1 244.5,245.6 250.2,263.3  " />
        <polygon fill="#FFFFFF" points="280,234.1 258,264.3 242.9,253.3  " />
        <polygon fill="#FFFFFF" points="280,277.9 258,247.7 242.9,258.7  " />
        <polygon fill="#FFFFFF" points="280,277.9 244.5,266.4 250.2,248.7  " />
      </g>
    </BaseIcon>
  );
}

export default IconFlagTu;